module.exports = __webpack_public_path__ + "img/banner4.a4d0c91a.jpg";